import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const MediaSection = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const slideWidth = 576;
  const images = [
    {
      large: "assets/upload/image/media-1.jpg",
      thumb: "assets/upload/image/media-small-1.jpg",
    },
    {
      large: "assets/upload/image/media-2.jpg",
      thumb: "assets/upload/image/media-small-2.jpg",
    },
    {
      large: "assets/upload/image/media-3.jpg",
      thumb: "assets/upload/image/media-small-3.jpg",
    },
    {
      large: "assets/upload/image/media-4.jpg",
      thumb: "assets/upload/image/media-small-4.jpg",
    },
    {
      large: "assets/upload/image/media-5.jpg",
      thumb: "assets/upload/image/media-small-5.jpg",
    },
  ];

  useEffect(() => {
    // Media section index changed
  }, [selectedIndex]);

  const handleNext = () => {
    setSelectedIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const [activeModal, setActiveModal] = useState(null);

  const openModal = (id) => {
    setActiveModal(id);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <div className="col-xs-12 col-sm-12 col-md-12 disable">
      <div className="row">
        <div className="col-xs-12">
          <div className="block media">
            <div className="header">
              <h3>MEDİA</h3>
              <div className="header-right">
                <ul>
                  <li>
                    <Link to="/images">MEDİA GALERİYE GİT</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div id="section-media">
              <div
                className="pictures-section"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}>
                {/* Büyük Resim */}
                <div
                  className="sp-slides-container"
                  style={{ position: "relative", width: `${slideWidth}px` }}>
                  <div
                    className="sp-mask sp-grab"
                    style={{
                      width: slideWidth,
                      height: 300,
                      overflow: "hidden",
                    }}>
                    <div
                      className="sp-slides"
                      style={{
                        width: `${images.length * slideWidth}px`,
                        display: "flex",
                        transform: `translateX(-${
                          selectedIndex * slideWidth
                        }px)`,
                        transition: "transform 0.5s ease-in-out",
                      }}>
                      {images.map((img, index) => (
                        <div
                          key={index}
                          className={`sp-slide ${
                            index === selectedIndex ? "sp-selected" : ""
                          }`}
                          style={{
                            width: `${slideWidth}px`,
                            height: 300,
                            flexShrink: 0,
                            ...(index === selectedIndex && {
                              position: "relative",
                              left: `${selectedIndex * slideWidth}px`,
                            }),
                          }}>
                          <div
                            className="sp-image-container"
                            style={{ width: "100%", height: "100%" }}>
                            <img
                              src={img.large}
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Navigation Arrows */}
                  <div
                    className="sp-arrows sp-fade-arrows"
                    style={{
                      position: "absolute",
                      top: "50%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      transform: "translateY(-50%)",
                      zIndex: 2, // <-- önemli!
                      pointerEvents: "none", // alt öğeler için engel olmasın
                    }}>
                    <div
                      className="sp-arrow sp-previous-arrow"
                      onClick={handlePrev}
                      style={{
                        background: "#333",
                        color: "#fff",
                        padding: "10px",
                        cursor: "pointer",
                        pointerEvents: "auto", // sadece butonlar tıklanabilsin
                      }}>
                      ◀
                    </div>
                    <div
                      className="sp-arrow sp-next-arrow"
                      onClick={handleNext}
                      style={{
                        background: "#333",
                        color: "#fff",
                        padding: "10px",
                        cursor: "pointer",
                        right: 0,
                        pointerEvents: "auto", // sadece butonlar tıklanabilsin
                      }}>
                      ▶
                    </div>
                  </div>
                </div>

                {/* Küçük Resimler */}
                <div
                  className="sp-thumbnails-container"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    width: slideWidth,
                  }}>
                  {images.map((img, index) => (
                    <div
                      key={index}
                      className={`sp-thumbnail-container ${
                        index === selectedIndex ? "sp-selected-thumbnail" : ""
                      }`}
                      style={{
                        width: 100,
                        height: 70,
                        border:
                          index === selectedIndex
                            ? "2px solid #84663e"
                            : "1px solid #ccc",
                        borderRadius: 4,
                        cursor: "pointer",
                        opacity: index === selectedIndex ? 1 : 0.6,
                        overflow: "hidden",
                      }}
                      onClick={() => setSelectedIndex(index)}>
                      <img
                        src={img.thumb}
                        alt={`Thumbnail ${index}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Video Section */}
        <div className="col-xs-12">
          <div className="block">
            <div className="header">
              <h3>VİDEO</h3>
              <div className="header-right">
                <ul>
                  <li>
                    <Link to={"/movie"} >VİDEO GALERİYE GİT</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="video-block" style={{ display: "flex" }}>
              {[1, 2, 3, 4].map((num) => (
                <div className="video" key={num}>
                  <a
                    onClick={(e) => {
                      e.preventDefault()
                      openModal(`#video_modal-${num}`);
                    }}
                    className="video-img"
                    href="#!"
                    onKeyDown={(e) => e.preventDefault()}>
                    <img
                      src={`assets/images/video-img-${num}.jpg`}
                      alt={`Video ${num}`}
                    />
                  </a>
                  <h3>VİDEO-{num}</h3>
                </div>
              ))}
            </div>

            {/* Video Modals */}
            {[1, 2, 3, 4, 5].map((num) => (
              <div
                className="modal_window"
                id={`video_modal-${num}`}
                key={num}
                style={{
                  display:
                    activeModal === `#video_modal-${num}` ? "block" : "none",
                  position: "fixed",
                  top: "-40%",
                  left: "-40%",
                  width: "180%",
                  height: "180%",
                  backgroundColor: "rgba(0,0,0,0.7)",
                  zIndex: 1000,
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "40px",
                  boxSizing: "border-box",
                }}>
                <button
                  className="close_mw close-r"
                  onClick={closeModal}
                  style={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    color: "crimson",
                    fontSize: 30,
                    textDecoration: "none",
                    fontWeight: "bold",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    zIndex: 1001,
                  }}>
                  ✖
                </button>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/z6Ja5BUcLVw"
                  allowFullScreen
                  title={`video_modal-${num}`}
                  style={{
                    border: "none",
                    width: "100%",
                    height: "100%",
                    margin: "auto",
                    display: "block",
                    backgroundColor: "#000",
                  }}></iframe>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaSection;
